import { type ReactNode } from 'react'
import { Group, Stack, Text } from '@mantine/core'
import { type MaterialSymbolType, useTranslation } from '@front/model'
import { MaterialSymbolIcon } from '@components'

type Props = {
  companyName: string
  showRating: boolean
  rating: number | undefined
  iconColor: string
  textColor: string
}

type TrustItem = {
  icon: MaterialSymbolType
  label: string
}

export const PreviewTrustList = ({ companyName, showRating, rating, iconColor, textColor }: Props): ReactNode => {
  const { t } = useTranslation()
  const tenure: TrustItem = { icon: 'workspace_premium', label: t('3 yrs at {{companyName}}', { companyName }) }
  const ratingItem: TrustItem = { icon: 'star', label: t('{{rating}} rating', { rating: (rating ?? 4.9).toFixed(1) }) }
  const location: TrustItem = { icon: 'location_on', label: t('Local expert') }
  const items = showRating ? [tenure, ratingItem, location] : [tenure, location]

  return (
    <Stack gap='xs'>
      {items.map(({ icon, label }) => (
        <Group key={icon} gap='xs' wrap='nowrap'>
          <MaterialSymbolIcon color={iconColor} filled={icon === 'star'} icon={icon} size='md' />
          <Text c={textColor} fw={500} size='sm'>
            {label}
          </Text>
        </Group>
      ))}
    </Stack>
  )
}
